.l2ListBase {
    // Design has three columns being centered which doesn't work with grid, so
    // let's do flexbox instead

    // On desktop, we're treating each column as though it's in a layout that
    // shows four columns, even if only two or three columns are showing...
    // UNLESS there are more than four columns.

    // Have to do some math to account for gap widths.

    // --columns is set in NavPopover.tsx
    --gutters: calc(var(--columns) - 1);
    --gutter-width: var(--labui-grid-gap);
    --gutter-space: calc(var(--gutter-width) * var(--gutters));
    --width: calc((100% - var(--gutter-space)) / var(--columns));

    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    justify-content: center;
    gap: var(--labui-grid-gap);

    > li {
        flex: 0 0 var(--width);
    }
}

.l2List {
    composes: l2ListBase;
    composes: container from "../../styles/composable/layout.module.css";
}

.l2ListMobile {
    composes: l2ListBase;
    flex-direction: column;
}

.l2Base {
    composes: fontEyebrow from "../../styles/composable/typography.module.css";
}

.l2 {
    composes: l2Base;
    margin-bottom: var(--spacer-16);
}

.l2Mobile {
    composes: l2Base;
    padding-block: 16px;
    margin-bottom: 0;
}

.l3List {
    composes: listReset from "../../styles/composable/utility.module.css";
}

.l3 {
    composes: fontUppercase from "../../styles/composable/typography.module.css";
    margin-bottom: 8px;
    font: var(--font-p-14);

    svg {
        display: inline;
        width: 16px;
        height: 16px;
        fill: currentColor;
        margin: -0.2em 0 0 5px;
        vertical-align: middle;
    }
}

.l3Mobile {
    composes: l3;
    width: 100%;
    padding-block: 16px;
    padding-left: 16px;
    margin-bottom: 0;
}

.popoverBase {
    left: 0;
    width: 100%;
    background-color: var(--white);
    padding-block: var(--spacer-24);
    z-index: 1;
}

.popover {
    composes: popoverBase;
    position: fixed;
    top: var(--main-nav-height);
}

.mobilePopover {
    composes: popoverBase;
    position: relative;
    top: 0;
}

.underlay {
    position: fixed;
    inset: var(--main-nav-height) 0 0;
    background-color: rgb(var(--black-base) / 25%);
    z-index: 0;
}
